import { Button } from '@mui/material'
import { InformationModal } from 'utoniq-ui'

import { useTranslation } from '@/core'

export type ConfirmationRollGachaByTicketModalProps = {
  open: boolean
  onClose: () => void
  count: number
  gachaRolling: boolean
  onClick: () => void
}
/**
 * @description
 * ガチャを引く確定モーダル（チケット用）
 */
export const ConfirmationRollGachaByTicketModal = ({
  open,
  onClose,
  count,
  gachaRolling,
  onClick,
}: ConfirmationRollGachaByTicketModalProps) => {
  const { t } = useTranslation('gachaDetail')

  return (
    <InformationModal
      open={open}
      onClose={onClose}
      title={t('confirmRollGachaTitle')}
      content={t('confirmRollGachaDesc', { number: count })}
      cancelText={t('close')}
      buttons={
        <Button
          size="large"
          sx={{ width: 212 }}
          disabled={gachaRolling}
          loading={gachaRolling}
          onClick={onClick}
        >
          {t('draw')}
        </Button>
      }
    />
  )
}
